module.exports = __webpack_public_path__ + "static/media/wrl-barber-logo@2x.085db51c.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-barber-logo@2x.png
// module id = 1211
// module chunks = 0